<!-- Copyright Koninklijke Philips N.V. 2021 -->
<div class="login-flex-container">
  <div class="login-flex-left">
    <div class="login-image-bg">
      <img src="assets/images/clinicians.png" alt="Login Car" class="login-big-image">
    </div>
    <div class="login-logo-box">
      <h2 class="login-title">Brease Platform Prototype UI</h2>
      <div class="login-subtitle">Sign in to your account</div>
    </div>
  </div>
  <div class="login-flex-right">
    <form name="login-form" class="needs-validation login-form" (ngSubmit)="onSubmit($event)" novalidate>
      <div class="mb-3">
        <label for="username" class="form-label fw-semibold text-primary">Username</label>
        <input type="text" class="form-control form-control-lg fancy-input" id="username" name="username" [(ngModel)]="username" placeholder="Enter username" required autocomplete="username" [class.is-invalid]="!username && submitted">
        <div class="invalid-feedback">Username is required.</div>
      </div>
      <div class="mb-3">
        <label for="password" class="form-label fw-semibold text-primary">Password</label>
        <input type="password" class="form-control form-control-lg fancy-input" id="password" name="password" [(ngModel)]="password" placeholder="Enter password" required autocomplete="current-password" [class.is-invalid]="!password && submitted">
        <div class="invalid-feedback">Password is required.</div>
      </div>
      <div class="mb-3">
        <label for="applicationId" class="form-label fw-semibold text-primary">Application</label>
        <select id="applicationId" name="applicationId" class="form-select form-select-lg fancy-input" [(ngModel)]="selectedApplication" required [class.is-invalid]="!selectedApplication && submitted">
          <option [ngValue]="null" disabled>--Select--</option>
          <option *ngFor="let option of applicationOptions" [ngValue]="option.applicationId">
            {{ option.description }}
          </option>
        </select>
      </div>
      <button type="submit" class="btn btn-gradient w-100 py-2 fs-5 shadow-sm mb-2">Log In</button>
      <div class="text-center mt-1">
        <a href="#" class="link-primary text-decoration-none small">Forgot password?</a>
      </div>
    </form>
    <div class="pt-login-footer mt-4 text-center">
      <div class="pt-footer-icons mb-2">
        <i class="bi bi-journal-medical text-primary fs-4 me-2"></i>
        <i class="bi bi-shield-check text-success fs-4"></i>
      </div>
      <div class="pt-footer-paragraph text-secondary small">
        <p>{{copyRightText}}</p>
      </div>
    </div>
  </div>
</div>
